export const ROUTS = {
    HOME: '/',
    JOBS: '/jobs',
    NDA: '/nda',
    CASES: '/cases',
    CASE: '/case/cat',
    ABOUT: '/about',
    //DEVELOP: '/development',
    POLICY: '/privacy',
    SERVICE_PAGE: '/services',
    SERVICES: '/services/:service',
    BONUSES: '/bonuses',
    CONTACTS: '/contacts',


    CASE_GRANIT: '/case/granit-company',
    CASE_SWISS: '/case/swiss',
    CASE_PARTY_INTEL: '/case/party-intel',
    CASE_PAPPY_ELEPHANT: '/case/happy-elephant',
    CASE_OPTICS: '/case/optics',
    CASE_CENTAVRAS: '/case/centavras',
    CASE_RENT_CLUB: '/case/rent-club',
    CASE_SODOX: '/case/sodox',
    CASE_ART_MEDIA: '/case/art-media',
    CASE_SINARADESING: '/case/sinaradesign',

}